import CourseCategoryForm from "components/cms/CourseCategoryForm"
import EmployeeDashboardWrapper from "components/layouts/EmployeeDashboardWrapper"
import DefBreadcrumb from "components/ui/breadcrumb/DefBreadcrumb"
import Typography from "components/ui/typography"
import { getCMSSegments } from "utils/helper"

const CourseCategoryUpdate = () => {
  const segments = getCMSSegments()

  return (
    <EmployeeDashboardWrapper>
      <DefBreadcrumb
        segments={segments}
        prefix="cms"
      />
      <Typography
        variant="subheading4"
        as="h1"
        className="text-primary"
      >
        Update Kategori Pembelajaran
      </Typography>

      <CourseCategoryForm />
    </EmployeeDashboardWrapper>
  )
}

export default CourseCategoryUpdate
